export default class MessageOutput {
  to: string[] = [];
  body: string = "";
}
